import { render } from "./403.vue?vue&type=template&id=27731344&scoped=true&ts=true"
import script from "./403.vue?vue&type=script&lang=ts"
export * from "./403.vue?vue&type=script&lang=ts"

import "./403.vue?vue&type=style&index=0&id=27731344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27731344"]])

export default __exports__